import React, {FC, useState} from 'react';
import FontBody1 from '../../../../../components/fonts/font-body1/font-body1';
import {FONT_COLOR, FONT_VARIANT} from '../../../../../components/fonts/font-props';
import Card from '../../../../../components/layouts/card/card';
import customizationStore from '../../../../../stores/customizations/customization-store';
import {FormField} from '../../../../../components/form-field/form-field';
import {TRACKING_ERROR_MESSAGE_STYLE} from '../../../../../models/User';
import ControlGroupWithPreview from '../../../../../components/layouts/control-group-with-preview/control-group-with-preview';
import {observer} from 'mobx-react';
import {Toggle} from '../../../../../components/inputs/toggle/toggle';
import {IOption, SelectDropdown} from '../../../../../components/inputs/select-dropdown/select-dropdown';
import {FormFieldLine} from '../../../../../components/form-field-line/form-field-line';
import trackingEstimatedDateShown from '../../../../../images/previews/tracking-estimated-date-shown.svg';
import trackingEstimatedDateHidden from '../../../../../images/previews/tracking-estimated-date-hidden.svg';
import trackingErrorMessageStyleError from '../../../../../images/previews/tracking-error-message-error.svg';
import trackingErrorMessageStyleInfo from '../../../../../images/previews/tracking-error-message-info.svg';
import trackingErrorMessageStyleWarning from '../../../../../images/previews/tracking-error-message-warning.svg';

const GeneralCard: FC = observer(() => {

	const [isExpanded, setIsExpanded] = useState(false);
	const classicCustomizationStore = customizationStore.getClassicStore();

	const trackingEstimatedDatePreview = () => {
		if (classicCustomizationStore.orderTrackingShowETA) {
			return <img src={trackingEstimatedDateShown} alt="" />;
		}

		return <img src={trackingEstimatedDateHidden} alt="" />;
	}

	const trackingErrorMessageStylePreview = () => {
		switch (classicCustomizationStore.trackingErrorMessageStyle) {
			case TRACKING_ERROR_MESSAGE_STYLE.ERROR:
				return <img src={trackingErrorMessageStyleError} alt="" />;
			case TRACKING_ERROR_MESSAGE_STYLE.INFO:
				return <img src={trackingErrorMessageStyleInfo} alt="" />;
			case TRACKING_ERROR_MESSAGE_STYLE.WARNING:
				return <img src={trackingErrorMessageStyleWarning} alt="" />;
		}
	}

	const trackingErrorMessageStyleDDOptions: IOption[] = [
		{
			label: 'Error Message',
			value: TRACKING_ERROR_MESSAGE_STYLE.ERROR,
		},
		{
			label: 'Info Message',
			value: TRACKING_ERROR_MESSAGE_STYLE.INFO,
		},
		{
			label: 'Warning Message',
			value: TRACKING_ERROR_MESSAGE_STYLE.WARNING,
		},

	];

	const selectedTrackingErrorMessageStyle: IOption | undefined = trackingErrorMessageStyleDDOptions.find(option => option.value === classicCustomizationStore.trackingErrorMessageStyle);

	return (
		<Card
			toolbar={{
				title: <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>General</FontBody1>
			}}
			isExpanded={isExpanded}
			expandCallback={setIsExpanded}
		>
			<FormField label='Tracking Portal Settings'>
			</FormField>

			<ControlGroupWithPreview
				hasTopBorder={false}
				preview={<div className="preview">{trackingEstimatedDatePreview()}</div>}
			>
				<FormFieldLine
					label='Show estimated delivery date when available'
				>
					<Toggle
						label=""
						checked={classicCustomizationStore.orderTrackingShowETA}
						onChange={classicCustomizationStore.setOrderTrackingShowETA}
					/>
				</FormFieldLine>
			</ControlGroupWithPreview>


			<ControlGroupWithPreview
				hasTopBorder={false}
				preview={<div className="preview">{trackingErrorMessageStylePreview()}</div>}
			>
				<FormFieldLine
					label="'Shipment not found' Message Design"
					note='Choose how the message will appear to your customers'
				>
					<SelectDropdown
						options={trackingErrorMessageStyleDDOptions}
						value={selectedTrackingErrorMessageStyle}
						onChange={v => classicCustomizationStore.setTrackingErrorMessageStyle(v?.value as TRACKING_ERROR_MESSAGE_STYLE)}
					/>
				</FormFieldLine>
			</ControlGroupWithPreview>
		</Card>
	)
})

export default GeneralCard
